"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentLegacyEncryptor = void 0;

var __1 = require("../..");

var Configs_1 = require("../../Configs");

var interface_adapter_1 = require("../../Interfaces/interface.adapter");

var Adapters_1 = require("../../Adapters");

var rsa_1 = __importDefault(require("./vendor/rsa"));

var base64_1 = require("./vendor/base64");

var PaymentLegacyEncryptor =
/** @class */
function () {
  function PaymentLegacyEncryptor() {// Empty constructor
  }

  PaymentLegacyEncryptor.prototype.ingenicoEncryptCreditCardInfo = function (encodedSession, creditCard, billingContact) {
    return __awaiter(this, void 0, void 0, function () {
      var sessionInfo, ingenicoAdapter, encryptedCard, e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            sessionInfo = {
              id: "",
              vendorName: interface_adapter_1.PaymentVendors.ingenico,
              vendorSessionPayload: encodedSession,
              billingToken: "",
              timestamp: ""
            };
            ingenicoAdapter = new Adapters_1.PaymentAdapterIngenico(sessionInfo, billingContact);
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , new Promise(function (resolve, reject) {
              // eslint-disable-next-line prefer-const
              var timeoutId;
              ingenicoAdapter.encryptCreditCardData(creditCard).then(function (encryptedCardData) {
                clearTimeout(timeoutId);
                resolve(encryptedCardData);
              })["catch"](function (e) {
                clearTimeout(timeoutId);
                reject(e);
              });
              timeoutId = setTimeout(function () {
                reject("timeout");
              }, Configs_1.Config.defaultVendorTimeout);
            })];

          case 2:
            encryptedCard = _a.sent();
            return [3
            /*break*/
            , 4];

          case 3:
            e_1 = _a.sent();

            if (e_1 instanceof __1.PaymentClientError) {
              throw e_1;
            }

            throw new __1.PaymentTimeoutError("Payment time-out while waiting for vendor response");

          case 4:
            return [2
            /*return*/
            , encryptedCard];
        }
      });
    });
  };

  PaymentLegacyEncryptor.prototype.rsaEncryptCreditCardInfo = function (encryptionKey, creditCard) {
    return __awaiter(this, void 0, void 0, function () {
      var encryptedResult;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.rsaEncryptPanData(encryptionKey, "cc_no=" + creditCard.number + "&cvv=" + creditCard.securityCode)];

          case 1:
            encryptedResult = _a.sent();
            return [2
            /*return*/
            , encryptedResult];
        }
      });
    });
  };

  PaymentLegacyEncryptor.prototype.rsaEncryptACHInfo = function (encryptionKey, achInfo) {
    return __awaiter(this, void 0, void 0, function () {
      var encryptedResult;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.rsaEncryptPanData(encryptionKey, "bank_acct_no=" + achInfo.bankAccountNumber + "&bank_routing_no=" + achInfo.bankRoutingNumber)];

          case 1:
            encryptedResult = _a.sent();
            return [2
            /*return*/
            , encryptedResult];
        }
      });
    });
  };

  PaymentLegacyEncryptor.prototype.rsaEncryptECheckInfo = function (encryptionKey, eCheckInfo) {
    return __awaiter(this, void 0, void 0, function () {
      var driversLicenseData, encryptedResult;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            driversLicenseData = eCheckInfo.driverLicenseIssuingState + "" + eCheckInfo.driverLicenseNumber;
            return [4
            /*yield*/
            , this.rsaEncryptPanData(encryptionKey, "bank_acct_no=" + eCheckInfo.bankAccountNumber + "&bank_routing_no=" + eCheckInfo.bankRoutingNumber + "&check_no=" + eCheckInfo.checkNumber + "&driver_license_no=" + driversLicenseData)];

          case 1:
            encryptedResult = _a.sent();
            return [2
            /*return*/
            , encryptedResult];
        }
      });
    });
  };

  PaymentLegacyEncryptor.prototype.rsaEncryptEPaperTokenInfo = function (encryptionKey, ePaperTokenInfo) {
    return __awaiter(this, void 0, void 0, function () {
      var encryptedResult;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.rsaEncryptPanData(encryptionKey, "cc_no=" + ePaperTokenInfo.ePaperToken)];

          case 1:
            encryptedResult = _a.sent();
            return [2
            /*return*/
            , encryptedResult];
        }
      });
    });
  };

  PaymentLegacyEncryptor.prototype.rsaEncryptPanData = function (encryptionKey, panData) {
    return __awaiter(this, void 0, void 0, function () {
      var rsa, encryptedResult, encryptedPanData;
      return __generator(this, function (_a) {
        try {
          rsa = new rsa_1["default"]();
          rsa.setPublic(encryptionKey, "10001");
          encryptedResult = rsa.encrypt(panData);
          encryptedPanData = encryptedResult ? base64_1.hex2b64(encryptedResult) : null;

          if (!encryptedPanData) {
            throw new __1.PaymentClientError("Failed to encrypt payment data, please check the encryption key.", __1.PaymentErrorShortCodes.invalid_card_number_encryption_error);
          }

          return [2
          /*return*/
          , encryptedPanData];
        } catch (e) {
          throw new __1.PaymentClientError("Failed to encrypt payment data, please check the encryption key.", __1.PaymentErrorShortCodes.invalid_card_number_encryption_error, {
            cause: {
              message: e.message,
              details: JSON.stringify(e)
            },
            code: "BG-1065"
          });
        }

        return [2
        /*return*/
        ];
      });
    });
  };

  return PaymentLegacyEncryptor;
}();

exports.PaymentLegacyEncryptor = PaymentLegacyEncryptor;


// WEBPACK FOOTER //
// ./node_modules/@backoffice/fast-payments-client-js-sdk/build/src/PaymentClient/Legacy/Encryption/PaymentLegacyEncryptor.js